import {Schema} from "@oilstone/rest-model-repository";

const schema = new Schema();

schema.prop('id').setType(String).setValue(null).readOnly().primaryKey();
schema.prop('language').setType(String).setValue('en');
schema.prop('title').setType(String);

export default schema;
